import { VirtualGuideButton } from "@/components/ChatComposer";
import { VirtualGuideIcon } from "@/components/VirtualGuideIcon";
import { pairGeometry } from "@/components/chatStyles";

/* "Side Tabs — both vertical": the Virtual Guide as a slim vertical tab in the same style as the Chat-with-Us tab */
const GuideTab = ({ cfg, t, onClick, scale }) => {
  const off = cfg.voice_mode !== "on";
  const color = cfg.guide_color || t.launcher || t.accent, text = cfg.guide_text_color || t.launcherText || t.accentText;
  return (
    <button type="button" data-testid="guide-widget-btn" data-style="tab" aria-label={cfg.guide_label || "Virtual Guide"} onClick={onClick} disabled={off}
      className={`flex flex-col items-center gap-2 rounded-l-2xl px-2.5 py-4 hover:pr-3.5 transition-[padding,box-shadow] shadow-[0_14px_40px_rgba(26,46,38,0.28)] ring-2 ring-white/70 ${off ? "opacity-50" : ""}`}
      style={{ backgroundColor: color, color: text, transform: `scale(${scale})`, transformOrigin: "right center" }}>
      <span className="relative grid place-items-center w-9 h-9 rounded-full bg-white shadow-inner"><VirtualGuideIcon size={26} src={cfg.guide_icon_url} /></span>
      <span className="text-xs font-semibold tracking-wide [writing-mode:vertical-rl] rotate-180 py-1">{cfg.guide_label || "Virtual Guide"}</span>
    </button>
  );
};

/* Virtual Guide button on the website, positioned together with the Chat-with-Us launcher (admin: layout, order, gap, offsets, show/hide). */
export const GuideWidget = ({ placement, cfg, t, open, onClick, pos, scale = 1, mobile }) => {
  const geo = pairGeometry(cfg, placement, scale, mobile);
  if (!geo.showGuide || open) return null;
  return (
    <div className={`${pos} z-[93]`} style={geo.guide} data-testid="guide-widget" data-placement={placement} data-layout={cfg.pair_layout || "stacked"}>
      {placement === "side_tabs"
        ? <GuideTab cfg={cfg} t={t} onClick={onClick} scale={scale} />
        : <VirtualGuideButton cfg={cfg} t={t} mobile={mobile} onClick={onClick} testId="guide-widget-btn" className="shadow-[0_14px_40px_rgba(26,46,38,0.28)] ring-2 ring-white/70" />}
    </div>
  );
};
